module.exports = "### XSS injection\n\n- Cross-site scripting\n\n- Allows malicious JS code to be run on the user's machine\n\n- Manipulate accounts\n\n- Escape all the things\n\n- Tedious, one mistake opens up vulnerabilities\n"


//////////////////
// WEBPACK FOOTER
// ./src/slides/05_history/notes_3.md
// module id = 1484
// module chunks = 0